export default "__VITE_ASSET__BubL2ou8__"